<template>
  <section class="interviews-page">

    <!-- Попап подтверждения -->
    <ConfirmDialog
      :visible="confirmDialog.visible"
      :title="confirmDialog.title"
      :text="confirmDialog.text"
      :confirm-label="confirmDialog.confirmLabel"
      :cancel-label="confirmDialog.cancelLabel"
      @confirm="handleConfirmDialog"
      @cancel="closeConfirmDialog"
    />

    <!-- Preloader -->
    <transition name="fade">
      <section
        v-if="preloader"
        class="preloader-wrapper"
      >
        <v-container>
          <div class="text-center">
            <v-progress-circular indeterminate />
          </div>
        </v-container>
      </section>
    </transition>

    <transition name="fade">
      <div
        v-if="!preloader"
        class="interview"
      >
        <div
          v-for="type in types"
          :key="type"
          class="container-color"
        >
          <div class="flexBlock pd-block pl-0">
            <h3 class="custom-h3">{{ mapTitle[type] }}</h3>
          </div>

          <InterviewCard
            v-if="hasInterviews(type)"
            :is-admin="isAdmin"
            :type="getTypeLabel(type)"
            :interviews="interviews[type]"
            @goTo="goToInterview"
            @editInterview="editInterview"
            @delInterview="delInterview"
          />

          <div v-else class="container-color">
            <span class="empty-text">Нет запланированных интервью</span>
          </div>
        </div>

        <!-- Редактирование -->
         <v-dialog 
          v-if="editForm" 
          :value="value"
          @input="$emit('input', $event)" 
          max-width="500px"
         >
          <v-card class="cardCustom" style="padding: 10px 0 !important;">
              <v-btn
                class="close-button"
                title="Отменить"
                variant="text"
                text
                @click="closeEdit"
              >
                <v-icon>ti-close</v-icon>
              </v-btn>

              <InterviewEditForm
                :data="currentItem"
                :options="participantsOptions"
                @saveEditedInterview="saveEditedInterview"
              />
            </v-card>
         </v-dialog>
        
      </div>
    </transition>

  </section>
</template>

<script>
import InterviewCard from "@/components/Cards/InterviewCard";
import InterviewEditForm from "@/components/InterviewEditForm";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

import GlobalRequest from "@/plugins/globalRequest";
import globalMethods from "@/plugins/globalMethods";

export default {
  name: "Interviews",

  components: {
    InterviewCard,
    InterviewEditForm,
    ConfirmDialog
  },

  inject: ["usersStore"],

  data() {
    return {
      interviews: {},
      isAdmin: false,
      editForm: false,
      currentItem: null,
      preloader: true,
      mapTitle: {
        owned: "Инициатор",
        participated: "Участник",
        interviewed: "Назначенные"
      },
      type: ["", "info", "success", "warning", "danger"],
      test: {
        "owned": [
            {
                "id": 7,
                "title": "Тестовое  интервью",
                "date": "2025-09-18",
                "time": "15:51",
                "status": "created",
                "owner": {
                    "id": 17,
                    "login": "nmogilenko",
                    "email": "NAMogilenko@1bit.com",
                    "name": "Никита",
                    "secondName": "Андреевич",
                    "lastName": "Могиленко",
                    "avatar": "https://crm.cbitrix.com/upload/main/3f1/v9u9gehjqob4esusgzz7vvt2b66p0vjy/629.png",
                    "phone": "89998887760",
                    "mobile": "89998887765",
                    "telegram": "nikitameh",
                    "active": true
                },
                "interviewee": {
                    "id": 57,
                    "login": "AIKorunov",
                    "email": "AIKorunov@1cbit.ru",
                    "name": "Александр",
                    "secondName": "Игоревич",
                    "lastName": "Корунов",
                    "avatar": "https://crm.cbitrix.com/upload/main/850/11uj4h7x69kw500ltw8nxwel5bvrlp8w/photo_2024-03-26_14-26-09.jpg.png",
                    "phone": "",
                    "mobile": "+79267092769",
                    "telegram": null,
                    "active": true
                },
                "participants": [
                    {
                        "id": 24,
                        "login": "anazaytsev@1cbit.ru",
                        "email": "AnAZaytsev@1bit.com",
                        "name": "Андрей",
                        "secondName": "",
                        "lastName": "Зайцев",
                        "avatar": "https://crm.cbitrix.com/upload/main/2fc/xefaw7yydr4c0le134uwol5cf8q7fmdf/1648102639812.png",
                        "phone": "",
                        "mobile": "",
                        "telegram": "And_zaicev",
                        "active": true
                    },
                    {
                        "id": 56,
                        "login": "AnABelyaev@1bit.com",
                        "email": "AnABelyaev@1bit.com",
                        "name": "Антон ",
                        "secondName": "",
                        "lastName": "Беляев",
                        "avatar": null,
                        "phone": "+7 (988) 888 88-88",
                        "mobile": "",
                        "telegram": "belyash42",
                        "active": true
                    }
                ]
            }
        ],
        "participated": [],
        "interviewed": [],
      },
      value: true,
      confirmDialog: {
        visible: false,
        title: "Подтвердите действие",
        text: "",
        confirmLabel: "ОК",
        cancelLabel: "Отмена",
        action: null
      },
    };
  },

  computed: {
    types() {
      return Object.keys(this.interviews);
    },

    users() {
      return this.usersStore.users;
    },

    participantsOptions() {
      if (!this.users || !this.currentItem) return [];

      const currentUserId = localStorage.getItem('current_user');

      let usersPart = [];
      for (const user of this.users) {
        if (
          String(user.id) !== String(currentUserId)
        ) {
          usersPart.push({
            id: user.id,
            title: `${user.name} ${user.lastName || ""}`,
            img: user.avatar || "noFoto"
          });
        }
      }

      return usersPart;
    },

  },

  created() {
    this.initialize();
  },

  mounted() {
    var roles = globalMethods.getRoles();
    this.isAdmin = globalMethods.isAdmin(roles);
  },

  methods: {
    async initialize() {
      this.preloader = true;

      var userID = localStorage.getItem("current_user");
      if (!userID) {
        this.interviews = {};
        this.preloader = false;
        return;
      }

      let result = await GlobalRequest.request( "/interviews/user/" + userID, "GET");
      this.interviews = result && result.data ? result.data : {};

      // this.interviews = this.test;

      this.preloader = false;
    },

    hasInterviews(type) {
      return (
        this.interviews[type] &&
        this.interviews[type].length > 0
      );
    },

    getTypeLabel(type) {
      if (type === "owned") return "Инициатор";
      if (type === "participated") return "Участник";
      if (type === "interviewed") return "Кандидат";
      return "";
    },

    goToInterview(item) {
      this.$router.push({
        name: "InterviewDetail",
        query: {
          back: this.$route.name,
          id: item.id
        }
      });
    },

    editInterview(item) {
      this.currentItem = item;
      this.editForm = true;
    },

    delInterview(item) {

      this.openConfirmDialog({
        text: "Подтвердите удаление интервью",
        confirmLabel: "Удалить",
        action: () => this.confirmDelete(item.id)
      });
      
      console.log(item)
      // this.notifyVue('bottom', 'right', 3, "Удаление интервью будет позже");
    },

    async confirmDelete(id) {
      this.closeConfirmDialog();

      if (!id) {
        return;
      }

      const res = await GlobalRequest.request("/interviews/delete/" + id, "DELETE");
      if(res.success) {
        this.notifyVue('bottom', 'right', 2, "Интервью удалено");
        this.closeEdit();
        await this.initialize();
      }
      else {
        this.notifyVue('bottom', 'right', 4, "Произошла ошибка при удалении интервью");
      }

    },

    closeEdit() {
      this.editForm = false;
      this.currentItem = null;
    },

    async saveEditedInterview(result) {
      if(result.success) {
        this.notifyVue('bottom', 'right', 2, "Интервью было успешно изменено");

        this.patchInterviewInLists(result.data);

        this.closeEdit();
        // await this.initialize();
        return;
      }
      else {
        this.notifyVue('bottom', 'right', 4, "Произошла ошибка при изменении интервью");
      }
    },

    notifyVue(verticalAlign, horizontalAlign, color, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color],
        message: text,
      });
    },

    // Попап
    openConfirmDialog(config) {
      this.confirmDialog.visible = true;
      this.confirmDialog.title = config.title || "Подтвердите действие";
      this.confirmDialog.text = config.text || "";
      this.confirmDialog.confirmLabel = config.confirmLabel || "ОК";
      this.confirmDialog.cancelLabel = config.cancelLabel || "Отмена";
      this.confirmDialog.action = config.action || null;
    },

    closeConfirmDialog() {
      this.confirmDialog.visible = false;
      this.confirmDialog.text = "";
      this.confirmDialog.action = null;
    },

    handleConfirmDialog() {
      if (this.confirmDialog.action) {
        // Функция
        this.confirmDialog.action();
      }
    },

    patchInterviewInLists(updated) {
      if (!updated || !updated.id) return;

      // { owned: [...], participated: [...], interviewed: [...] }
      for (const key in this.interviews) {
        const arr = this.interviews[key];
        if (!Array.isArray(arr)) continue;

        const idx = arr.findIndex(i => String(i.id) === String(updated.id));
        if (idx !== -1) {
          arr.splice(idx, 1, updated);
          break;
        }
      }
    },

  }
};
</script>

<style>
  .empty-text {
    font-family: "Montserrat", sans-serif;
    color: #89929d;
    font-size: 14px;
  }
  .flexBlock h3 {
    margin: 0 0 20px !important;
  }
  .preloader-wrapper {
    position: absolute;
    width: 100%;
  }
</style>
